/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AuditTrailEventViewModel
 */
export interface AuditTrailEventViewModel {
    /**
     * 
     * @type {string}
     * @memberof AuditTrailEventViewModel
     */
    eventDetail: string;
    /**
     * 
     * @type {Date}
     * @memberof AuditTrailEventViewModel
     */
    eventDate: Date;
    /**
     * 
     * @type {string}
     * @memberof AuditTrailEventViewModel
     */
    signatoryContact: string;
    /**
     * 
     * @type {boolean}
     * @memberof AuditTrailEventViewModel
     */
    isError: boolean;
}

/**
 * Check if a given object implements the AuditTrailEventViewModel interface.
 */
export function instanceOfAuditTrailEventViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "eventDetail" in value;
    isInstance = isInstance && "eventDate" in value;
    isInstance = isInstance && "signatoryContact" in value;
    isInstance = isInstance && "isError" in value;

    return isInstance;
}

export function AuditTrailEventViewModelFromJSON(json: any): AuditTrailEventViewModel {
    return AuditTrailEventViewModelFromJSONTyped(json, false);
}

export function AuditTrailEventViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuditTrailEventViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'eventDetail': json['EventDetail'],
        'eventDate': (new Date(json['EventDate'])),
        'signatoryContact': json['SignatoryContact'],
        'isError': json['IsError'],
    };
}

export function AuditTrailEventViewModelToJSON(value?: AuditTrailEventViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'EventDetail': value.eventDetail,
        'EventDate': (value.eventDate.toISOString()),
        'SignatoryContact': value.signatoryContact,
        'IsError': value.isError,
    };
}

